export default __webpack_public_path__ + "static/network-2-b922b82f0ef6f253f8ab950337c7bce5.png";